import Vue from 'vue'
import App from './App.vue'
import HighchartsVue from 'highcharts-vue'
import vuetify from './plugins/vuetify';
import store from "./store";
import VueMeta from 'vue-meta'
import router from './router'// loads from src/router/index.js
import axios from 'axios'


Vue.prototype.$http = axios
console.log(process.env.VUE_APP_API_URL)
// Sets the default url used by all of this axios instance's requests
axios.defaults.baseURL = process.env.VUE_APP_API_URL

if (axios.defaults.baseURL === undefined) {
  axios.defaults.baseURL = 'https://api.mortgage-comparison.org/api'
}
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import Vuex from 'vuex'
Vue.use(Vuex)

Vue.config.productionTip = false
Vue.use(HighchartsVue)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
